<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Dislike" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#F34E4A;}
	.st1{fill:#FFFFFF;}
</style>
<circle class="st0" cx="256" cy="256" r="256"/>
<path class="st1" d="M218.5,401.4c-16.9-3.4-28-19.9-24.6-36.8l1.5-7.4c3.5-17.4,9.8-33.9,18.8-49h-93.8c-17.3,0-31.3-14-31.3-31.3
	c0-12.1,6.8-22.5,16.9-27.8c-7.1-5.7-11.7-14.5-11.7-24.4c0-15.2,10.9-28,25.3-30.7c-2.9-4.8-4.5-10.3-4.5-16.2
	c0-13.9,9.1-25.7,21.6-29.7c-0.5-2.2-0.7-4.4-0.7-6.8c0-17.3,14-31.3,31.3-31.3h63.5c12.4,0,24.4,3.6,34.7,10.5l25.1,16.7
	c17.4,11.6,27.8,31.1,27.8,52.1v25v31.3v16.2c0,19-8.7,36.9-23.5,48.9l-4.8,3.8c-17.3,13.8-29.1,33.2-33.4,54.9l-1.5,7.4
	C251.9,393.7,235.4,404.7,218.5,401.4L218.5,401.4z M401.9,297.7h-41.7c-11.5,0-20.9-9.3-20.9-20.9v-146c0-11.5,9.3-20.9,20.9-20.9
	h41.7c11.5,0,20.9,9.3,20.9,20.9v146C422.7,288.4,413.4,297.7,401.9,297.7z"/>
</svg>
